import React from "react"
import TableHeaderRow from "../../ui/TableHeaderRow"
import TableHeader from "../../ui/TableHeader"
import Table, { Row, Cell } from "../../ui/Table"
import PropTypes from "prop-types"
import { useSelector } from "react-redux"
import { selectAdvancedMode } from "../settings/slice"
import Timestamp from "../../ui/Timestamp"
import IDCopy from "../../ui/IDCopy"
import AstrositeName from "../astrosites/AstrositeName"
import DropDownFilter from "../filters/DropDownFilter"
import SortHeader from "../sorting/SortHeader"
import { selectAstrositesById } from "../astrosites/slice"

/**
 * Renders a list of timelapses matching the filters
 *
 * @param timelapses
 * @param filter
 * @param setFilter
 * @param stickyHeader
 * @returns {JSX.Element}
 * @constructor
 */
const TimelapsesTable = ({
  timelapses = [],
  filter = {},
  setFilter = () => {},
  stickyHeader = true,
  hideFilters = false,
}) => {
  const advancedMode = useSelector(selectAdvancedMode)
  const astrositesByIds = useSelector(selectAstrositesById)

  return (
    <Table>
      <TableHeaderRow sticky={stickyHeader}>
        {advancedMode && <TableHeader>ID</TableHeader>}
        <TableHeader
          filterControl={
            (!hideFilters && (
              <DropDownFilter
                values={Object.keys(astrositesByIds).map((a) => ({
                  name: a,
                  value: a,
                }))}
                filterByName="astrosite"
                filter={filter}
                setFilter={setFilter}
                active={!!filter.astrosite}
              />
            )) ||
            undefined
          }
          sortControl={
            (!hideFilters && (
              <SortHeader
                setFilter={setFilter}
                filter={filter}
                sortBy={"astrosite_id"}
              />
            )) ||
            undefined
          }
        >
          Astrosite
        </TableHeader>
        <TableHeader
          sortControl={
            (!hideFilters && (
              <SortHeader
                setFilter={setFilter}
                filter={filter}
                sortBy={"start_time"}
              />
            )) ||
            undefined
          }
        >
          Start Time
        </TableHeader>
        <TableHeader>End Time</TableHeader>
        <TableHeader>File Name</TableHeader>
        <TableHeader>Frame Count</TableHeader>
      </TableHeaderRow>
      {timelapses && (
        <tbody>
          {timelapses.map((timelapse) => (
            <Row key={timelapse.id} zebra>
              {advancedMode && (
                <Cell>
                  <IDCopy truncateTo={20} id={timelapse.id} showCopy={true} />
                </Cell>
              )}
              <Cell>
                <AstrositeName
                  astrositeId={timelapse.astrosite}
                  showLinkIcon={false}
                />
              </Cell>
              <Cell>
                <Timestamp utc={advancedMode} columnMode={true}>
                  {timelapse.start_time}
                </Timestamp>
              </Cell>
              <Cell>{timelapse.end_time}</Cell>
              <Cell>{timelapse.file_name}</Cell>
              <Cell>{timelapse.frame_count}</Cell>
            </Row>
          ))}
        </tbody>
      )}
    </Table>
  )
}

TimelapsesTable.propTypes = {
  timelapses: PropTypes.array, // the timelapses descriptors to render
  filter: PropTypes.object, // If provided will be used to power the filters if not filters will not be shown
  setFilter: PropTypes.func, // If provided will be used to power the filters if not filters will not be shown
  stickyHeader: PropTypes.bool, // If true, table header is sticky
  hideFilters: PropTypes.bool, // If provided hides the filters for the table
}

export default TimelapsesTable
